import { IconButton, Stack } from '@adc/parallax-component-library';

import MenuIcon from '~/icons/menu.svg?react';
import { buildTestId } from '~/utils/buildTestId';

import { LactateLogoGradient } from '../LactateLogoGradient';

type Props = {
  testID: string;
  hideSelectMenu?: boolean;
};

export const AppMenuItemButton = ({
  testID,
  hideSelectMenu = false,
}: Props) => (
  <Stack flexDirection="row" alignItems="center" testID={testID}>
    {!hideSelectMenu && (
      <IconButton
        testID={buildTestId({
          testID,
          suffix: 'select',
        })}
        aria-label="Select menu"
        variant="tertiary"
        size="XS"
        marginLeft="$2"
        onPress={() => {
          // Empty function to handle the button press
        }}
      >
        <MenuIcon
          size="XS"
          accentColor="$surface.brand"
          testID={buildTestId({ testID, suffix: ['select', 'icon'] })}
        />
      </IconButton>
    )}

    <LactateLogoGradient testID={buildTestId({ testID, suffix: 'logo' })} />
  </Stack>
);
